import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'

import { StoreContext } from 'store/context'
import { createColumns } from './columns.description'
import TeamsOverviewComponent from './component'

export const TeamsOverview = combine(
  withTableController({ id: 'teams-table' }),
  withContext(
    'adminTeamsService',
    ServicesContext,
    ({ adminTeamsService }) => adminTeamsService
  ),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withCallbacks(
    {
      loadTeams:
        ({ appStore }) =>
        (tableState, _table, query) => {
          return appStore.adminTeams.loadTeams({
            name: query?.teamName,
            sportType: query?.sportTypes,
            page: tableState.page,
            size: tableState.pageSize,
            sort: tableState.sorted,
          })
        },

      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(TeamsOverviewComponent)
